import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { LEGAL_SLUGS } from 'app/api/models/legal-document';
import { legalDocumentUrl } from 'app/core/legal/legal.constants';

/**
 * The layout footer's legal row: a link to each legal document and the line saying
 * Books is software, not tax, accounting or legal advice. Links open in a new tab so
 * the page (often a half-filled form) stays open.
 */
@Component({
    selector: 'legal-footer',
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoDirective],
    template: `
        <ng-container *transloco="let t">
            <nav [attr.aria-label]="t('legal.footer.label')">
                <ul class="flex flex-wrap gap-x-3 gap-y-1">
                    @for (link of links; track link.slug) {
                        <li>
                            <a
                                class="text-secondary hover:text-primary hover:underline"
                                [href]="link.url"
                                target="_blank"
                                rel="noopener"
                                >{{ t('legal.footer.' + link.slug) }}</a
                            >
                        </li>
                    }
                </ul>
            </nav>
            <p class="legal-footer-notice text-hint text-xs">{{ t('legal.footer.notice') }}</p>
        </ng-container>
    `,
    host: { class: 'flex flex-col gap-0.5 text-sm' },
})
export class LegalFooterComponent {
    readonly links = LEGAL_SLUGS.map((slug) => ({ slug, url: legalDocumentUrl(slug) }));
}
